<div class="embed-container">

    <iframe class="" frameborder="0" [src]="urlSafe" allowfullscreen></iframe>
        
</div>